import { combineReducers } from 'redux';
import { ExampleReactPageReducer } from '../Scripts/Greatit.Cms/Pages/exampleReactPage/ExampleReactPage.reducer';
import { navigation } from "../Scripts/Components/Navigation/Navigation.reducer";
import { language } from "../Scripts/Components/Language/Language.reducer";
import { search } from "../Scripts/Components/Search/Search.reducer";
import { NewsPageReducer } from "../Scripts/Greatit.Cms/Pages/newsPage/NewsPage.reducer";
import { ProductListPageReducer } from "../Scripts/Greatit.Cms/Pages/productPage/ProductListPage.reducer";
import { ContactPageReducer } from "../Scripts/Greatit.Cms/Pages/ContactPage/ContactPage.reducer";
import { ApplicationPageReducer } from "../Scripts/Greatit.Cms/Pages/applicationPage/ApplicationPage.reducer";
import { TaxListPageReducer } from "../Scripts/Greatit.Cms/Pages/taxPage/TaxListPage.reducer";

const staticReducers = {
    ExampleReactPageReducer,
    NewsPageReducer,
    navigation,
    language,
    ProductListPageReducer,
    ContactPageReducer,
    search,
    ApplicationPageReducer,
    TaxListPageReducer
};

const app = combineReducers(staticReducers);

export const createReducer = (asyncReducers) => {
    return combineReducers({
        ...staticReducers,
        ...asyncReducers,
    });
};

export default app;
